<!-- vue-spinner 1.0.3 (https://github.com/greyby/vue-spinner.git) MIT License -->
<template>
<div class="v-spinner" v-show="loading">
    <div class="v-bounce v-bounce1" v-bind:style="spinnerBasicStyle">
    <div class="v-bounce v-bounce2" v-bind:style="spinnerStyle">
    </div><div class="v-bounce v-bounce3" v-bind:style="spinnerStyle">
    </div></div>
  </div>
</template>

<script>
export default {

  name: 'BounceSpinner',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: 'rgb(29, 29, 50)'
    },
    size: {
      type: String,
      default: '40px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data () {
    return {
      spinnerStyle: {
        background: this.color,
        height: this.size,
        width: this.size,
        borderRadius: this.radius,
        opacity: 0.4,
        position: 'absolute',
        top: 0,
        left: 0
      }
    }
  },
  computed: {
    spinnerBasicStyle () {
      return {
        height: this.size,
        width: this.size,
        position: 'relative'
      }
    }
  }
}
</script>

<style lang="sass">
.v-spinner .v-bounce

.v-spinner .v-bounce1


.v-spinner .v-bounce2
    animation: v-bounceStretchDelay 2s 1s infinite ease-in-out
    animation-fill-mode: both

.v-spinner .v-bounce3
    animation: v-bounceStretchDelay 2s 0s infinite ease-in-out
    animation-fill-mode: both


@-webkit-keyframes v-bounceStretchDelay
    0%, 100%
        transform: scale(0)
    50%
        transform: scale(1.0)

@keyframes v-bounceStretchDelay
    0%, 100%
        transform: scale(0)
    50%
        transform: scale(1.0);
</style>



// WEBPACK FOOTER //
// src/components/BounceSpinner.vue